module.exports = __webpack_public_path__ + "img/onlineBuyAct.6bf9ecb7.png";